module.exports = __webpack_public_path__ + "img/depot_analytics_5.1de1f5c2.jpeg";